import api from '../utils/api';

const emailNotificationPrefService = {
  // Get email notification preferences for a dataroom
  getPreferences: async (dataroomUuid) => {
    try {
      const response = await api.get(`/datarooms/${dataroomUuid}/email-notification-pref`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update email notification preferences for a dataroom
  updatePreferences: async (dataroomUuid, preferences) => {
    try {
      const response = await api.put(
        `/datarooms/${dataroomUuid}/email-notification-pref`,
        preferences
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete email notification preferences for a dataroom (reset to default)
  deletePreferences: async (dataroomUuid) => {
    try {
      const response = await api.delete(`/datarooms/${dataroomUuid}/email-notification-pref`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validate time format (HH:MM)
  validateTimeFormat: (time) => {
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timeRegex.test(time);
  },

  // Frequency options for the dropdown
  getFrequencyOptions: () => [
    { value: '1h', label: 'Every Hour' },
    { value: '6h', label: 'Every 6 Hours' },
    { value: '12h', label: 'Every 12 Hours' },
    { value: '24h', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: '15d', label: 'Every 15 Days' },
    { value: 'monthly', label: 'Monthly' }
  ]
};

export default emailNotificationPrefService;